<template>
  <div class="container">
    <sys-filter :filters.sync="filters" :server="true" :items="items" :filtered_items.sync="filtered_items" @getItems="getItems"/>
    <div class="row pb-5">
      <sys-widget title="Cantidad de Prospectos" :content="meta.total" icon="users" />
      <sys-widget title="Inversión estimada" :content="meta.total_amount | formatCurrency" icon="dollar-sign" color="secondary"/>
    </div>
    <sys-server-table :headers="headers" :tableData="tableData" :pagination="pagination" :items="items" :title="title" :error_message="error_message" :detail_route="detail_route" :create_route="create_route" @getItems="getItems" />
  </div>
</template>

<script>
import prospectsService from '@/services/prospects'
import SysServerTable from '@/components/shared/ServerTable'
import SysFilter from '@/components/shared/Filter'
import SysWidget from '@/components/shared/Widget'
import formatCurrency from '@/filters/formatCurrency'
import reverseDate from '@/filters/reverseDate'

export default {
  name: 'Prospects',

  components: { SysServerTable, SysFilter, SysWidget },
  created () {
    this.getItems()
  },
  data () {
    return {
      title: 'Prospectos',
      headers: [
        { text: 'Id', value: 'id' },
        { text: 'Nombre', value: 'name' },
        { text: 'Promotor', value: 'promoter_name' },
        { text: 'Inversión Mínima', value: 'investment', filter: formatCurrency },
        { text: 'Inversión Máxima', value: 'investment_end', filter: formatCurrency },
        { text: 'Fecha Desde', value: 'investment_date' },
        { text: 'Fecha Hasta', value: 'investment_date_end' },
        { text: 'Correo electrónico', value: 'email' },
        { text: 'Telefono', value: 'mobile' },
        { text: 'Último Contacto', value: 'latestEntry.data.date' },
        { text: 'Estatus', value: 'status_description' }
      ],
      items: [],
      filtered_items: [],
      items_sum: 0,
      error_message: 'There\'s nothing to show :c',
      detail_route: 'prospect',
      create_route: 'prospect_create',
      tableData: {
        draw: 0,
        length: 10,
        search: '',
        column: 0,
        dir: 'desc'
      },
      meta: {
        total: 0,
        total_amount: 0
      },
      pagination: {
        lastPage: '',
        currentPage: '',
        total: '',
        links: {},
        from: 1,
        to: 10
      },
      filters: [
        {
          id: 'name',
          name: 'Nombre Prospecto',
          hint: 'Prospecto',
          icon: 'user',
          type: 'text',
          value: '',
          validator: (item, value) => item.name.toLowerCase().includes(value.toLowerCase()) || (item.corporate_name && item.corporate_name.toLowerCase().includes(value.toLowerCase()))
        },
        {
          id: 'promoter',
          name: 'Nombre Promotor',
          hint: 'Promotor',
          icon: 'user',
          type: 'text',
          value: '',
          validator: (item, value) => item.promoter.toLowerCase().includes(value.toLowerCase())
        },
        {
          id: 'email',
          name: 'Correo',
          hint: 'Correo electrónico',
          icon: 'mail-bulk',
          type: 'text',
          value: '',
          validator: (item, value) => item.email.toLowerCase().includes(value.toLowerCase())
        },
        {
          id: 'date_from',
          name: 'Fecha Desde',
          hint: 'dd/mm/yyyy',
          icon: 'calendar-alt',
          type: 'date',
          size: 3,
          value: '',
          validator: (item, value) => new Date(item.investment_date) >= new Date(reverseDate(value))
        },
        {
          id: 'date_to',
          name: 'Fecha Hasta',
          hint: 'dd/mm/yyyy',
          icon: 'calendar-alt',
          type: 'date',
          size: 3,
          value: '',
          validator: (item, value) => new Date(item.investment_date) <= new Date(reverseDate(value))
        },
        {
          id: 'investment_from',
          name: 'Inversión Desde',
          hint: '$0.00',
          icon: 'dollar-sign',
          type: 'number',
          size: 3,
          value: '',
          validator: (item, value) => item.investment >= value
        },
        {
          id: 'investment_to',
          name: 'Inversión Hasta',
          hint: '$0.00',
          icon: 'dollar-sign',
          type: 'number',
          size: 3,
          value: '',
          validator: (item, value) => item.investment <= value
        }
      ]
    }
  },
  methods: {
    getItems (page = 1, filters = []) {
      this.tableData.draw++
      let params = this.tableData
      if (filters != null) {
        Object.assign(params, filters)
      } else {
        this.tableData = {
          draw: 1,
          length: 10,
          search: '',
          column: 0,
          dir: 'desc'
        }
        params = this.tableData
      }
      params.page = page
      prospectsService.list(params)
        .then(response => {
          let data = response
          this.items = data.data
          let meta = data.meta
          this.meta.total = meta.total
          this.meta.total_amount = meta.total_amount
          this.configPagination(data.meta.pagination)
        })
        .catch(errors => {
          console.log(errors)
        })
    },
    configPagination (data) {
      this.pagination.lastPage = data.total_pages
      this.pagination.currentPage = data.current_page
      this.pagination.total = data.total
      this.pagination.links = (data.links) ? data.links : {}
      this.pagination.to = data.count * data.current_page
      this.pagination.from = this.pagination.to - data.count + 1
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
</style>



// WEBPACK FOOTER //
// src/components/prospects/Prospects.vue